import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { KillSwitchGuard } from './guards/kill-switch-guard';
import { DeviceSuspendedComponent } from './shared/components/device-suspended/device-suspended.component';
import { APP_ROUTES } from './shared/utils';
import { AppGuardService, CloudDeploymentGuardService } from './guards';
import { DefaultLayoutComponent, MobileLayoutComponent } from './layouts';

const routes: Routes = [
  {
    path: 'rear-loading',
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import('./rear-loading/rear-loading.module').then((m) => m.RearLoadingModule),
    canActivate: [CloudDeploymentGuardService, AppGuardService, KillSwitchGuard],
  },
  {
    path: 'front-loading',
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import('./front-loading/front-loading.module').then((m) => m.FrontLoadingModule),
    canActivate: [CloudDeploymentGuardService, AppGuardService],
  },
  {
    path: APP_ROUTES.TTW.replace('/', ''),
    component: DefaultLayoutComponent,
    loadChildren: () => import('./ttw/ttw.module').then((m) => m.TtwModule),
    canActivate: [CloudDeploymentGuardService, AppGuardService],
  },
  {
    path: 'retail',
    component: DefaultLayoutComponent,
    loadChildren: () => import('./retail/retail.module').then((m) => m.RetailModule),
    canActivate: [CloudDeploymentGuardService, AppGuardService],
  },
  {
    path: 'setup',
    component: DefaultLayoutComponent,
    loadChildren: () => import('./setup/setup.module').then((m) => m.SetupModule),
    canActivate: [CloudDeploymentGuardService, AppGuardService],
  },
  {
    path: 'remote-pickup',
    component: MobileLayoutComponent,
    loadChildren: () =>
      import('./remote-pickup/remote-pickup.module').then((m) => m.RemotePickupModule),
    canActivate: [AppGuardService],
  },
  {
    path: APP_ROUTES.HARD_RELOAD.replace('/', ''),
    loadChildren: () => import('./hard-reload/hard-reload.module').then((m) => m.HardReloadModule),
  },
  {
    path: 'device-suspended',
    component: DeviceSuspendedComponent,
  },
  {
    path: '**',
    redirectTo: 'setup',
    pathMatch: 'full',
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
